import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { ReCaptchaService } from '@app/core/recaptcha/re-captcha.service';
import { Subscription } from 'rxjs';
import { RecaptchaData } from '@app/core/recaptcha/recaptcha-commons';

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecaptchaComponent implements AfterViewInit, OnDestroy {
  @ViewChild('container') public container: ElementRef;

  @Output() public data = new EventEmitter<RecaptchaData>();

  private subscription = new Subscription();

  constructor(private recaptchaService: ReCaptchaService) { }

  public ngAfterViewInit(): void {
    const sub = this.recaptchaService.createCheckbox(this.container.nativeElement)
      .subscribe(
        data => this.data.emit(data),
      );
    this.subscription.add(sub);
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
